import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PageURL } from '@router/pageURL';
import {
  ALL_FILTER_OPTION,
  productTypeFilterOptions,
  productRangeFilterOptions,
  productCategoryFilterOptions,
} from '../types';
import { createNewProductAccessUsers, IProductsToolbarProps } from './types';
import { Select } from '@components/common/Select/Select';
import { ISelectOption } from '@components/common/Select/types';
import {
  defaultSelectOptionFormatter,
  formatProductRangeFilterOptions,
  formatMaxFTVOptions,
  formatProductTypeFilterOptions,
  formatProductCategoryFilterOptions,
} from './helpers';
import { Checkbox } from '@components/common/Checkbox';
import { AccessWrapper } from '@components/AccessWrapper/AccessWrapper';
import { Button } from 'antd';
import { TextField } from '@components/common/TextField/TextField';
export const ProductsToolbar: FC<IProductsToolbarProps> = ({ onSearch, searchValue, productList, onFiltersChange }) => {
  const filterSelectClassName = 'h-10! w-26! pl-2 [&_.ant-select-selector]:px-2!';

  return (
    <div className={'mb-2 flex items-center justify-between gap-3'}>
      <TextField
        value={searchValue}
        onChange={event => onSearch(event as React.ChangeEvent<HTMLInputElement>)}
        placeholder={'Search'}
        className={'h-10! w-64'}
        data-testid={'productsSearchBar'}
      />

      <section className={'flex flex-wrap items-center justify-center gap-x-3 gap-y-2'}>
        <div className={'flex items-center'}>
          <label htmlFor={'productCategoryFilter'} className={'text-ash mr-2 whitespace-nowrap text-sm'}>
            <FormattedMessage id={'product.filters.productCategory'} />
          </label>
          <Select
            id={'productCategoryFilter'}
            disableClearable
            defaultValue={defaultSelectOptionFormatter(ALL_FILTER_OPTION)}
            name={'productCategoryFilter'}
            className={filterSelectClassName}
            onChange={(_event: React.ChangeEvent<HTMLSelectElement>, option: ISelectOption | null) =>
              option ? onFiltersChange('productCategory', option.value) : undefined
            }
            options={formatProductCategoryFilterOptions(productCategoryFilterOptions)}
            data-testid={'productCategoryFilter'}
          />
        </div>

        <div className={'flex items-center'}>
          <label htmlFor={'ftvFilter'} className={'text-ash mr-2 whitespace-nowrap text-sm'}>
            <FormattedMessage id={'product.filters.FTV'} />
          </label>
          <Select
            id={'ftvFilter'}
            disableClearable
            defaultValue={defaultSelectOptionFormatter(ALL_FILTER_OPTION)}
            name={'ftvFilter'}
            className={filterSelectClassName}
            onChange={(_event: React.ChangeEvent<HTMLSelectElement>, option: ISelectOption | null) =>
              option ? onFiltersChange('ftv', option.value) : undefined
            }
            options={formatMaxFTVOptions(productList)}
            data-testid={'ftvFilter'}
          />
        </div>

        <div className={'flex items-center'}>
          <label htmlFor={'productTypeFilter'} className={'text-ash mr-2 whitespace-nowrap text-sm'}>
            <FormattedMessage id={'product.filters.productType'} />
          </label>
          <Select
            id={'productTypeFilter'}
            disableClearable
            defaultValue={defaultSelectOptionFormatter(ALL_FILTER_OPTION)}
            name={'productTypeFilter'}
            className={filterSelectClassName}
            onChange={(_event: React.ChangeEvent<HTMLSelectElement>, option: ISelectOption | null) =>
              option ? onFiltersChange('productType', option.value) : undefined
            }
            options={formatProductTypeFilterOptions(productTypeFilterOptions)}
            data-testid={'productTypeFilter'}
          />
        </div>

        <div className={'flex items-center'}>
          <label htmlFor={'productRangeFilter'} className={'text-ash mr-2 whitespace-nowrap text-sm'}>
            <FormattedMessage id={'product.filters.productRange'} />
          </label>
          <Select
            id={'productRangeFilter'}
            disableClearable
            defaultValue={defaultSelectOptionFormatter(ALL_FILTER_OPTION)}
            name={'productRangeFilter'}
            className={filterSelectClassName}
            onChange={(_event: React.ChangeEvent<HTMLSelectElement>, option: ISelectOption | null) =>
              option ? onFiltersChange('productRange', option.value) : undefined
            }
            options={formatProductRangeFilterOptions(productRangeFilterOptions)}
            data-testid={'productRangeFilter'}
          />
        </div>

        <div className={'flex items-center'}>
          <label htmlFor={'productStateFilter'} className={'text-ash mr-2 whitespace-nowrap text-sm'}>
            <FormattedMessage id={'product.filters.productState'} />
          </label>
          <Checkbox
            name={'productStateFilter'}
            onChange={event => onFiltersChange('isActiveProductsOnly', event.target.checked)}
            data-testid={'productStateFilter'}
          />
        </div>
      </section>
      <AccessWrapper accessGroups={createNewProductAccessUsers}>
        <Link to={PageURL.PRODUCTS_NEW} className={'shrink-0 text-white no-underline'}>
          <Button type={'primary'}>Add new product</Button>
        </Link>
      </AccessWrapper>
    </div>
  );
};
